export default {
  SEARCH: 1,
  DETAILS: 2
};
